import React from "react";
import Herosection from "./Components/Herosection";
import AboutSection from "./Components/AboutSection";
import Category from "./Components/Category.jsx";
import AppDownloadSection from "./Components/Appdownloadsection.jsx";
import Footer from "./Components/Footer.jsx";

function App() {
  return (
    <div>
      <Herosection />
      <AboutSection />
      <Category />
      <AppDownloadSection />
      <Footer />
    </div>
  );
}

export default App;
